import { BoxProps } from '@mui/material';
import { memo } from 'react';
// @mui

// ----------------------------------------------------------------------

function EyeOpenIcon(): BoxProps {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.2004 10C12.2004 11.2154 11.2151 12.2008 9.99967 12.2008C8.78423 12.2008 7.79892 11.2154 7.79892 10C7.79892 8.78456 8.78423 7.79925 9.99967 7.79925C11.2151 7.79925 12.2004 8.78456 12.2004 10Z"
        stroke="#6B7280"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 9.99998C3.93479 7.02376 6.71528 4.86491 9.99999 4.86491C13.2847 4.86491 16.0652 7.02379 17 10C16.0652 12.9762 13.2847 15.1351 10 15.1351C6.71527 15.1351 3.93477 12.9762 3 9.99998Z"
        stroke="#6B7280"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default memo(EyeOpenIcon);
